// extracted by mini-css-extract-plugin
export var backdrop = "Toast-module--backdrop--ff8cb";
export var card = "Toast-module--card--dfacd";
export var close = "Toast-module--close--345c3";
export var cta = "Toast-module--cta--69cad";
export var fadeIn = "Toast-module--fadeIn--84e32";
export var iconCircle = "Toast-module--iconCircle--7c73e";
export var iconWrap = "Toast-module--iconWrap--32084";
export var message = "Toast-module--message--97a4e";
export var popIn = "Toast-module--popIn--36778";
export var title = "Toast-module--title--9c54d";